<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<h1 class="chapter">PREFACE</h1>
<p class="nonindent">T<span class="small">HIS</span> volume is somewhat ‘off’ the ‘beaten track’ of books on Trees, and the author believes that it will be found to contain a considerable amount of information of a kind that will be new even to usually well-informed readers.</p>
<p class="indent">Happily the study of nature-subjects generally is now very much in evidence, and the recognition by our educational authorities of the importance of nature-teaching will keep the minds of the rising generation in a very desirable groove.</p>
<p class="indent">An alphabetical arrangement of the contents of this volume has been adopted for the easy reference of the reader; and the chapter on Indigenous British Trees and Shrubs, giving names, heights, time of flowering, and colours of flowers, should prove to be a useful novelty.</p>
<p class="indent">The Glossarial Index will show at a glance the extent of the information laboriously gathered together; but it has been a genuine ‘labour of love.’</p>
<p class="right"><strong>F<span class="small">RANCIS</span> G<span class="small">EORGE</span> H<span class="small">EATH</span>.</strong></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pre.vue?406f624e